import React, { useEffect, useState } from 'react';
import { getUserData } from '../../../../../services/API'
import { Tooltip, tooltipTypes } from '../../../../Global/Tooltip';
import Dropdown from '../../../../Global/Dropdown';
import { useSelector } from 'react-redux';
import defaultCurriculumConfig from './defaultCurriculumConfig';
import { getCurriculumOptions } from './getCurriculumOptions';
import cx from 'classnames';
import './index.scss';
import { localesUnderscoreMap } from '../../../../../constants/constants';

export default function SelectSkillsCurriculum(props) {
  const { isLoading, isDisabled, handleChangeCurriculum } = props;

  const { curriculum: configuredCurriculum } = getUserData(); // curriculums configured from by admin
  //example: {locale: 'EN_US', curriculumId: 'eps-spire', displayName: 'EPS Spire'}
  const selectedCurriculum = useSelector(state => state?.reports?.teacher?.selectedCurriculum); // selected curriculum by teacher
  const locale = useSelector(state => state?.reports?.teacher?.selectedLocale); // selected data locale by teacher

  const [curriculumOptions, setOptions] = useState([]);

  useEffect(() => {
    // if locale is changed, update the curriculum options
    if(locale) {
      setOptions(getCurriculumOptions(configuredCurriculum, locale));
    }
  }, [locale, configuredCurriculum]);


  if(!curriculumOptions?.length) return null;

  const curriculumDropdownClass = cx('reportsAdditionalSelectionDropdown', {
    'hidden': curriculumOptions.length === 1 && curriculumOptions[0].value === defaultCurriculumConfig[locale].curriculumId
  });

  const defaultValue = selectedCurriculum || curriculumOptions[0];

  return <div className={curriculumDropdownClass}>
      <div className="reportsAdditionalSelectionTitle"> CURRICULUM
        <Tooltip type={tooltipTypes.curriculum} />
      </div>
      <Dropdown
        options={curriculumOptions}
        value={defaultValue}
        onChange={handleChangeCurriculum}
        isDisabled={isDisabled}
        isLoading={isLoading}
      />
    </div>
  
}
  
